import React, { Component } from 'react'
import InfoBlock from '../shared/infoBlock'
import AngleBracketButton from '../shared/angleBracketButton'
import CollapsableCard from '../shared/collapsableCard'
import { isNarrowDesktop, Default, isTablet, Mobile } from '../../media-queries'
import Fade from 'react-reveal/Fade'
import Step from './step'
import AngleBracket from '../shared/angleBracket'

export default class ApplicationKnowledge extends Component {
  state = {
    infoText: '',
    selected: {},
  }

  render() {
    return (
      <div>
        <Default>
          <DefaultApplicationKnowledge
            {...this.props}
            {...this.state}
            legalisationsButtonProps={this.buttonProps('legalisations')}
            tuitionAndScholarshipsButtonProps={this.buttonProps(
              'tuitionAndScholarships'
            )}
            contactButtonProps={this.buttonProps('contact')}
            conditionalContinue={this.conditionalContinue}
            showInfo={this.showInfo}
          />
        </Default>
        <Mobile>
          <MobileApplicationKnowledge
            {...this.props}
            {...this.state}
            conditionalContinue={this.conditionalContinue}
            setSelected={target =>
              this.setState(prevState => ({
                selected: { ...prevState.selected, [target]: undefined },
              }))
            }
          />
        </Mobile>
      </div>
    )
  }

  showInfo = target =>
    this.setState(prevState => ({
      infoText: target,
      selected: { ...prevState.selected, [target]: undefined },
    }))

  conditionalContinue = () => {
    if (Object.keys(this.state.selected).length === 3) {
      this.props.nextStep()
    }
  }

  buttonProps = target => ({
    style: {
      border:
        Object.keys(this.state.selected).indexOf(target) !== -1 &&
        '3px solid white',
      background:
        Object.keys(this.state.selected).indexOf(target) !== -1
          ? 'none'
          : 'white',
    },
    textStyle: {
      color:
        Object.keys(this.state.selected).indexOf(target) !== -1
          ? 'white'
          : 'black',
    },
    hasCaret: Object.keys(this.state.selected).indexOf(target) === -1,
    hasShadow: Object.keys(this.state.selected).indexOf(target) === -1,
  })
}

const DefaultApplicationKnowledge = props => (
  <div
    style={{
      display: 'flex',
    }}
  >
    <div
      style={{
        background: '#F7F7F7',
        minHeight: props.height,
        padding: isTablet()
          ? '2rem 4rem 3rem'
          : `2rem ${isNarrowDesktop() ? '5rem' : '7rem'} 2rem 5rem`,
        width: '58vw',
      }}
    >
      <InfoBlock
        title={props.header.title}
        bigTitle={true}
        extra={props.header.titleAccent}
        accentColor={'#8CBD8C'}
        text={props.header.text.internal.content}
      />
      <div
        style={{
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
          }}
        >
          <Fade when={props.infoText === 'legalisations'} collapse>
            <InfoBlock
              title={props.legalisations}
              text={props.legalisationsText.internal.content}
            />
          </Fade>
        </div>
        <div
          style={{
            position: 'absolute',
          }}
        >
          <Fade when={props.infoText === 'tuitionAndScholarships'} collapse>
            <InfoBlock
              title={props.tuitionAndScholarships}
              text={props.tuitionAndScholarshipsText.internal.content}
            />
          </Fade>
        </div>
        <div
          style={{
            position: 'absolute',
          }}
        >
          <Fade when={props.infoText === 'contact'} collapse>
            <InfoBlock
              title={props.contact}
              text={props.contactText.internal.content}
            />
          </Fade>
        </div>
      </div>
    </div>
    <SideContent {...props} />
  </div>
)

const MobileApplicationKnowledge = props => (
  <div
    style={{
      background: 'white',
    }}
  >
    <InfoBlock
      title={props.header.title}
      extra={props.header.titleAccent}
      accentColor={'#8CBD8C'}
      text={props.header.text.internal.content}
      style={{ padding: '1rem 2rem' }}
    />
    <div style={{ margin: '0 3rem', paddingBottom: '1rem' }}>
      <div
        style={{
          color: 'white',
          fontSize: 20,
          fontWeight: 700,
          marginBottom: '.5rem',
        }}
      >
        <Step
          {...props.step}
          accentColor={'#8CBD8C'}
          style={{ color: 'black' }}
        />
      </div>
    </div>
    <div style={{ margin: '1rem 2rem' }}>
      <CollapsableCard
        title={props.legalisations}
        text={props.legalisationsText.internal.content}
        className={'card'}
        style={{ background: '#F7F7F7', marginBottom: '0.5rem' }}
        onClick={() => props.setSelected('legalisations')}
      />
      <CollapsableCard
        title={props.tuitionAndScholarships}
        text={props.tuitionAndScholarshipsText.internal.content}
        className={'card'}
        style={{ background: '#F7F7F7', marginBottom: '0.5rem' }}
        onClick={() => props.setSelected('tuitionAndScholarships')}
      />
      <CollapsableCard
        title={props.contact}
        text={props.contactText.internal.content}
        className={'card'}
        style={{ background: '#F7F7F7', marginBottom: '0.5rem' }}
        onClick={() => props.setSelected('contact')}
      />
    </div>
    <div
      style={{
        margin: '1rem 3rem',
        fontStyle: 'italic',
        fontSize: '12px',
      }}
    >
      {props.explanationDegrees}
    </div>
    <div
      style={{
        margin: '2rem 2rem',
        border: `3px solid ${
          Object.keys(props.selected).length === 3 ? '#8CBD8C' : '#f7f7f7'
        }`,
        padding: '1.5em',
        textAlign: 'center',
        color: Object.keys(props.selected).length === 3 ? 'black' : '#f7f7f7',
        fontSize: 18,
        fontWeight: 600,
        background: Object.keys(props.selected).length === 3 ? '#8CBD8C' : '',
        cursor: Object.keys(props.selected).length === 3 ? 'pointer' : '',
      }}
      className={`unselectable ${
        Object.keys(props.selected).length === 3 ? 'card' : ''
      }`}
      onClick={props.conditionalContinue}
    >
      {props.applicationProcedure}
    </div>
    <div
      style={{
        margin: '1rem 3rem',
        fontStyle: 'italic',
        fontSize: 12,
      }}
    >
      {props.closingText}
    </div>
    <div
      style={{
        padding: '2rem 2rem 3rem',
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <div onClick={props.previousStep} style={{ cursor: 'pointer' }}>
        <AngleBracket
          color={'black'}
          style={{
            width: 5,
            transform: 'scaleX(-1)',
            filter: 'FlipH',
          }}
        />
        <span>&nbsp;&nbsp;Back</span>
      </div>
    </div>
  </div>
)

const SideContent = props => (
  <div
    style={{
      background: '#8CBD8C',
      minHeight: props.height,
      padding: `15vh ${isNarrowDesktop() ? '8vw' : '12.5vw'} 1rem ${
        isNarrowDesktop() ? '1rem' : '3rem'
      }`,
      width: '42vw',
    }}
  >
    <div style={{ marginBottom: '3rem' }}>
      <Step {...props.step} />
    </div>
    <div>
      <AngleBracketButton
        caretPosition={'left'}
        caretDirection={'left'}
        onClick={() => props.showInfo('legalisations')}
        text={props.legalisations}
        {...props.legalisationsButtonProps}
        style={{
          marginTop:
            Object.keys(props.selected).indexOf('legalisations') !== -1
              ? -6
              : 0,
          ...props.legalisationsButtonProps.style,
        }}
      />
      <AngleBracketButton
        caretPosition={'left'}
        {...props.tuitionAndScholarshipsButtonProps}
        style={{
          marginBottom:
            Object.keys(props.selected).indexOf('tuitionAndScholarships') !== -1
              ? ' calc(.5rem - 3px)'
              : '.5rem',
          marginTop:
            Object.keys(props.selected).indexOf('tuitionAndScholarships') !== -1
              ? ' calc(.5rem - 3px)'
              : '.5rem',
          ...props.tuitionAndScholarshipsButtonProps.style,
        }}
        caretDirection={'left'}
        onClick={() => props.showInfo('tuitionAndScholarships')}
        text={props.tuitionAndScholarships}
      />
      <AngleBracketButton
        caretPosition={'left'}
        caretDirection={'left'}
        onClick={() => props.showInfo('contact')}
        text={props.contact}
        {...props.contactButtonProps}
        style={{
          marginBottom:
            Object.keys(props.selected).indexOf('contact') !== -1 ? -6 : 0,
          ...props.contactButtonProps.style,
        }}
      />
      <div
        style={{
          marginTop: '3rem',
          border: '3px solid white',
          padding: '1.5em',
          textAlign: 'center',
          color: Object.keys(props.selected).length === 3 ? 'black' : 'white',
          fontSize: 18,
          fontWeight: 600,
          background:
            Object.keys(props.selected).length === 3 ? 'white' : 'none',
          cursor: Object.keys(props.selected).length === 3 ? 'pointer' : '',
        }}
        className={`unselectable ${
          Object.keys(props.selected).length === 3 ? 'card' : ''
        }`}
        onClick={props.conditionalContinue}
      >
        {props.applicationProcedure}
      </div>
    </div>
    <div
      style={{
        margin: '2rem 0 3rem',
        fontStyle: 'italic',
        fontSize: 12,
      }}
    >
      {props.closingText}
    </div>
    <div
      style={{
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <div onClick={props.previousStep} style={{ cursor: 'pointer' }}>
        <AngleBracket
          color={'black'}
          style={{
            width: 5,
            transform: 'scaleX(-1)',
            filter: 'FlipH',
          }}
        />
        <span>&nbsp;&nbsp;Back</span>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/application/applicationKnowledge.js